import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'mentorshipLog'

const initialState = {
  list: null,
  count: null,
}

export const searchLogs = createApiAction('mentorship/log/search', client.search('/api/mentorship/:mentorshipId/log'))
export const retrieveLog = createApiAction('mentorship/log/retrieve', client.retrieve('/api/mentorship/:mentorshipId/log/:id'))
export const saveLog = createApiAction('mentorship/log/save', client.save('/api/mentorship/:mentorshipId/log'))
export const destroyLog = createApiAction('mentorship/log/destroy', client.destroy('/api/mentorship/:mentorshipId/log/:id'))

const updateLogList = (state, action) => {
  const item = action.payload
  const found = state.list?.find(l => l.id === item.id)
  state.list = found
    ? state.list.map(l => (l.id === item.id ? item : l))
    : [...(state.list || []), item]
}

const logSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearLogs: state => {
      state.list = null
      state.count = null
    },
  },
  extraReducers(builder) {
    builder
      .addCase(searchLogs.fulfilled, (state, action) => {
        state.list = action.payload.rows
        state.count = action.payload.count
      })
      .addCase(saveLog.fulfilled, updateLogList)
      .addCase(destroyLog.fulfilled, (state, action) => {
        state.list = state.list?.filter(l => l.id !== action.payload.id)
      })
  },
})

export const { clearLogs } = logSlice.actions
export default logSlice.reducer
